module.exports = __webpack_public_path__ + "static/media/1-virat.cb209896.png";